import { useMediaQuery as mediaQuery } from '@mantine/hooks'

import { breakpoints } from '../../src/themes/mantine/tokens'

export function useMediaQuery() {
  const isMobile = mediaQuery(`(max-width:${breakpoints.sm})`)
  const isTablet = mediaQuery(`(max-width:${breakpoints.md})`)
  const isDesktop = mediaQuery(`(min-width:${breakpoints.lg})`)
  const hasMaxSize = (size: number) => mediaQuery(`(max-width:${size}px)`)
  const isSafari =
    typeof window !== 'undefined' &&
    /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

  return {
    isMobile,
    isTablet,
    isDesktop,
    isSafari,
    hasMaxSize,
  }
}
